import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram, Youtube } from 'lucide-react'
import { useState } from 'react'
import { Meteors } from './ui/meteors'
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics'

export default function Footer() {
  const { trackSocialClick } = useGoogleAnalytics()
  const [showSeoKeywords, setShowSeoKeywords] = useState(false)

  const seoKeywords = [
    {
      location: "Pune",
      courses: [
        "Data Science Course Training in Pune",
        "Machine learning course training in pune",
        "data analytics course training in pune",
        "business analytics course training in pune",
        "artificial intelligence AI course training pune",
        "Full stack software developer course in Pune",
        "Cloud Computing Course in Pune",
        "DevOps Course Training in Pune",
        "AWS DevOps Training in Pune",
        "Azure DevOps Training in Pune",
        "Docker Kubernetes Training in Pune",
        "Jenkins CI/CD Training in Pune"
      ]
    },
    {
      location: "Mumbai",
      courses: [
        "Data Science Course Training in Mumbai",
        "Machine learning course training in Mumbai",
        "data analytics course training in Mumbai",
        "business analytics course training in Mumbai",
        "artificial intelligence AI course training in Mumbai",
        "Full stack software developer course in Mumbai",
        "DevOps Course Training in Mumbai",
        "AWS DevOps Training in Mumbai",
        "Azure DevOps Training in Mumbai",
        "Docker Kubernetes Training in Mumbai",
        "Jenkins CI/CD Training in Mumbai"
      ]
    },
    {
      location: "Chennai",
      courses: [
        "Data Science Course Training in Chennai",
        "Machine learning course training in Chennai",
        "data analytics course training in Chennai",
        "business analytics course training in Chennai",
        "artificial intelligence AI course training in Chennai",
        "Full stack software developer course in Chennai",
        "DevOps Course Training in Chennai",
        "AWS DevOps Training in Chennai",
        "Azure DevOps Training in Chennai",
        "Docker Kubernetes Training in Chennai",
        "Jenkins CI/CD Training in Chennai"
      ]
    },
    {
      location: "Canada",
      courses: [
        "Data Science Course Training in Canada",
        "Machine learning course training in Canada",
        "data analytics course training in Canada",
        "business analytics course training in Canada",
        "artificial intelligence AI course training in Canada",
        "Full stack software developer course in Canada",
        "DevOps Course Training in Canada",
        "AWS DevOps Training in Canada",
        "Azure DevOps Training in Canada",
        "Docker Kubernetes Training in Canada",
        "Jenkins CI/CD Training in Canada"
      ]
    },
    {
      location: "Bangalore",
      courses: [
        "Data Science Course Training in Bangalore",
        "Machine learning course training in Bangalore",
        "data analytics course training in Bangalore",
        "business analytics course training in Bangalore",
        "artificial intelligence AI course training in Bangalore",
        "Full stack software developer course in Bangalore",
        "Cloud Computing Course in Bangalore",
        "DevOps Course Training in Bangalore",
        "AWS DevOps Training in Bangalore",
        "Azure DevOps Training in Bangalore",
        "Docker Kubernetes Training in Bangalore",
        "Jenkins CI/CD Training in Bangalore"
      ]
    },
    {
      location: "Hyderabad",
      courses: [
        "Data Science Course Training in Hyderabad",
        "Machine learning course training in Hyderabad",
        "data analytics course training in Hyderabad",
        "business analytics course training in Hyderabad",
        "artificial intelligence AI course training in Hyderabad",
        "Full stack software developer course in Hyderabad",
        "DevOps Course Training in Hyderabad",
        "AWS DevOps Training in Hyderabad",
        "Azure DevOps Training in Hyderabad",
        "Docker Kubernetes Training in Hyderabad",
        "Jenkins CI/CD Training in Hyderabad"
      ]
    },
    {
      location: "Dubai",
      courses: [
        "Data Science Course Training in Dubai",
        "Machine learning course training in Dubai",
        "data analytics course training in Dubai",
        "business analytics course training in Dubai",
        "artificial intelligence AI course training Dubai",
        "Full stack software developer course in Dubai",
        "DevOps Course Training in Dubai",
        "AWS DevOps Training in Dubai",
        "Azure DevOps Training in Dubai",
        "Docker Kubernetes Training in Dubai",
        "Jenkins CI/CD Training in Dubai"
      ]
    },
    {
      location: "Delhi",
      courses: [
        "Data Science Course Training in Delhi",
        "Machine learning course training in Delhi",
        "data analytics course training in Delhi",
        "business analytics course training in Delhi",
        "artificial intelligence AI course training in Delhi",
        "Full stack software developer course in Delhi",
        "DevOps Course Training in Delhi",
        "AWS DevOps Training in Delhi",
        "Azure DevOps Training in Delhi",
        "Docker Kubernetes Training in Delhi",
        "Jenkins CI/CD Training in Delhi"
      ]
    },
    {
      location: "Kolkata",
      courses: [
        "Data Science Course Training in Kolkata",
        "DevOps Course Training in Kolkata",
        "AWS DevOps Training in Kolkata",
        "Azure DevOps Training in Kolkata",
        "Docker Kubernetes Training in Kolkata"
      ]
    },
    {
      location: "Bhubaneswar",
      courses: [
        "Data Science Course Training in Bhubaneswar",
        "DevOps Course Training in Bhubaneswar",
        "AWS DevOps Training in Bhubaneswar",
        "Azure DevOps Training in Bhubaneswar",
        "Docker Kubernetes Training in Bhubaneswar"
      ]
    },
    {
      location: "Nagpur",
      courses: [
        "Data Science Course Training in Nagpur",
        "DevOps Course Training in Nagpur",
        "AWS DevOps Training in Nagpur",
        "Azure DevOps Training in Nagpur",
        "Docker Kubernetes Training in Nagpur"
      ]
    },
    {
      location: "Jaipur",
      courses: [
        "Data Science Course Training in Jaipur",
        "DevOps Course Training in Jaipur",
        "AWS DevOps Training in Jaipur",
        "Azure DevOps Training in Jaipur",
        "Docker Kubernetes Training in Jaipur"
      ]
    },
    {
      location: "Coimbatore",
      courses: [
        "Data Science Course Training in coimbatore",
        "DevOps Course Training in Coimbatore",
        "AWS DevOps Training in Coimbatore",
        "Azure DevOps Training in Coimbatore",
        "Docker Kubernetes Training in Coimbatore"
      ]
    },
    {
      location: "Patna",
      courses: [
        "Data Science Course Training in Patna",
        "DevOps Course Training in Patna",
        "AWS DevOps Training in Patna",
        "Azure DevOps Training in Patna",
        "Docker Kubernetes Training in Patna"
      ]
    },
    {
      location: "Noida",
      courses: [
        "Data Science Course Training in Noida",
        "DevOps Course Training in Noida",
        "AWS DevOps Training in Noida",
        "Azure DevOps Training in Noida",
        "Docker Kubernetes Training in Noida"
      ]
    },
    {
      location: "Marathahalli",
      courses: [
        "Data Science Course Training in Marathahalli",
        "DevOps Course Training in Marathahalli",
        "AWS DevOps Training in Marathahalli",
        "Azure DevOps Training in Marathahalli",
        "Docker Kubernetes Training in Marathahalli"
      ]
    },
    {
      location: "Indore",
      courses: [
        "Data Science Course Training in Indore",
        "DevOps Course Training in Indore",
        "AWS DevOps Training in Indore",
        "Azure DevOps Training in Indore",
        "Docker Kubernetes Training in Indore"
      ]
    },
    {
      location: "Kochi",
      courses: [
        "Data Science Course Training in Kochi",
        "DevOps Course Training in Kochi",
        "AWS DevOps Training in Kochi",
        "Azure DevOps Training in Kochi",
        "Docker Kubernetes Training in Kochi"
      ]
    },
    {
      location: "USA",
      courses: [
        "Data Science Course Training in USA",
        "Master's Degree in Data Science in USA",
        "DevOps Course Training in USA",
        "AWS DevOps Training in USA",
        "Azure DevOps Training in USA",
        "Docker Kubernetes Training in USA",
        "Jenkins CI/CD Training in USA"
      ]
    },
    {
      location: "South Africa",
      courses: [
        "Data Science Course Training in South africa",
        "DevOps Course Training in South Africa",
        "AWS DevOps Training in South Africa",
        "Azure DevOps Training in South Africa",
        "Docker Kubernetes Training in South Africa"
      ]
    },
    {
      location: "Nigeria",
      courses: [
        "Data Science Course Training in Nigeria",
        "DevOps Course Training in Nigeria",
        "AWS DevOps Training in Nigeria",
        "Azure DevOps Training in Nigeria",
        "Docker Kubernetes Training in Nigeria"
      ]
    },
    {
      location: "Singapore",
      courses: [
        "Data Science Course Training in Singapore",
        "DevOps Course Training in Singapore",
        "AWS DevOps Training in Singapore",
        "Azure DevOps Training in Singapore",
        "Docker Kubernetes Training in Singapore"
      ]
    },
    {
      location: "Bangladesh",
      courses: [
        "Data Science Course Training in Bangladesh",
        "Data Science Course Training in Dhaka",
        "DevOps Course Training in Bangladesh",
        "AWS DevOps Training in Bangladesh",
        "Azure DevOps Training in Bangladesh",
        "Docker Kubernetes Training in Bangladesh"
      ]
    },
    {
      location: "Vietnam",
      courses: [
        "Data Science Course Training in Vietnam",
        "DevOps Course Training in Vietnam",
        "AWS DevOps Training in Vietnam",
        "Azure DevOps Training in Vietnam",
        "Docker Kubernetes Training in Vietnam"
      ]
    },
    {
      location: "Malaysia",
      courses: [
        "Data Science Course Training in Malaysia",
        "DevOps Course Training in Malaysia",
        "AWS DevOps Training in Malaysia",
        "Azure DevOps Training in Malaysia",
        "Docker Kubernetes Training in Malaysia"
      ]
    },
    {
      location: "Germany",
      courses: [
        "Master's Degree in Data Science in germany",
        "DevOps Course Training in Germany",
        "AWS DevOps Training in Germany",
        "Azure DevOps Training in Germany",
        "Docker Kubernetes Training in Germany"
      ]
    },
    {
      location: "Austin",
      courses: [
        "Data Science Course Training in Austin",
        "DevOps Course Training in Austin",
        "AWS DevOps Training in Austin",
        "Azure DevOps Training in Austin",
        "Docker Kubernetes Training in Austin"
      ]
    },
    {
      location: "Egypt",
      courses: [
        "Data Science Course Training in Egypt",
        "DevOps Course Training in Egypt",
        "AWS DevOps Training in Egypt",
        "Azure DevOps Training in Egypt",
        "Docker Kubernetes Training in Egypt"
      ]
    },
    {
      location: "UK",
      courses: [
        "Data Science Course Training in UK",
        "DevOps Course Training in UK",
        "AWS DevOps Training in UK",
        "Azure DevOps Training in UK",
        "Docker Kubernetes Training in UK"
      ]
    },
    {
      location: "Australia",
      courses: [
        "Master's Degree in Data Science in Australia",
        "DevOps Course Training in Australia",
        "AWS DevOps Training in Australia",
        "Azure DevOps Training in Australia",
        "Docker Kubernetes Training in Australia"
      ]
    }
  ]

    const officeLocations = [
    {
      city: "Indore",
      state: "Madhya Pradesh",
      address: "1st floor, IDBI BANK, Plot no, Sapna Sangeeta Rd, Tower Square, Khatiwala Tank, Indore, Madhya Pradesh 452014",
      mapLink: "https://maps.app.goo.gl/Dur6YPXRh4CVBMXA7",
      status: "active",
      coordinates: { lat: 22.7196, lng: 75.8577 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Kothrud, Pune",
      state: "Maharashtra",
      address: "2nd floor, Kalpvrushksha Building, Mayur Colony, Kothrud, Pune Maharashtra 411038",
      mapLink: "https://maps.app.goo.gl/ajBN7kxy2JGsLaXK9",
      status: "active",
      coordinates: { lat: 18.5204, lng: 73.8567 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Wakad, Pune",
      state: "Maharashtra",
      address: "Office No. 502, 5th Floor, Bhama Center, Bhujbal Chowk, Hinjawadi Rd, Bhujbal Vasti, Wakad, Pimpri-Chinchwad, Maharashtra 411057",
      mapLink: "https://maps.app.goo.gl/pFCk2iK2aiD4wuEo9",
      status: "active",
      coordinates: { lat: 18.5998, lng: 73.7647 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Nagpur",
      state: "Maharashtra",
      address: "2nd Floor, Dev Heights, Above Carat Lane, Ring Road, Pratap Nagar Square, Tatya Tope Nagar, Pratap Nagar, Nagpur, Maharashtra – 440022",
      mapLink: "https://maps.app.goo.gl/E9kHAUTfwHYFMMmC6",
      status: "active",
      coordinates: { lat: 21.1458, lng: 79.0882 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Nashik",
      state: "Maharashtra",
      address: "2nd floor, Sakhare Arcade, above Biba Showroom, Opposite Anna Idli Restaurant, Near Canada Corner, College Road, Nashik, 422005",
      mapLink: "https://maps.app.goo.gl/r9nnBmE7H85TUz9N8",
      status: "active",
      coordinates: { lat: 19.9975, lng: 73.7898 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Kharadi, Pune",
      state: "Maharashtra",
      address: "15 3rd Floor, City Vista, Office No. 15A, 14A, A Wing, Fountain Road, Ashoka Nagar, Kharadi, Pune, Maharashtra 411014",
      mapLink: "https://maps.app.goo.gl/tGapV7NTkGhLiL6j7",
      status: "active",
      coordinates: { lat: 18.5529, lng: 73.9425 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Chakan, Pune",
      state: "Maharashtra",
      address: "Vishal Capital 2nd floor, office no 215 and 216, Gat no 1638 and 1648 pune Nashik Highway chakan Tal-khed, Dist- pune pin -410501",
      mapLink: "https://maps.app.goo.gl/LwuV3Tdf6eoV5gvh7?g_st=ic",
      status: "active",
      coordinates: { lat: 18.7505, lng: 73.8575 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Amravati",
      state: "Maharashtra",
      address: "Ground floor, Narayan Niketan, opp dr. Sune hospital, narayan niketan, Rajapeth, Amravati Maharastra - 444606",
      mapLink: "https://maps.app.goo.gl/8rk4HPT8cKWrKXXw8?g_st=ic",
      status: "active",
      coordinates: { lat: 20.9374, lng: 77.7796 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    },
    {
      city: "Ch. Sambhaji Nagar",
      state: "Maharashtra",
      address: "Coming Soon - New Training Center",
      mapLink: "#",
      status: "opening-soon",
      coordinates: { lat: 19.8762, lng: 75.3433 },
      phone: "+91-98348-87259",
      email: "info@cloudblitz.in",
      courses: ["Cloud DevOps Engineering", "Data Science", "Full Stack Development", "Digital Marketing", "Cloud Architect"]
    }
  ]

  // Generate structured data for locations
  const generateLocationStructuredData = () => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "CloudBlitz Training Centers",
      "description": "CloudBlitz training centers across India and internationally",
      "numberOfItems": officeLocations.length,
      "itemListElement": officeLocations.map((location, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "LocalBusiness",
          "name": `CloudBlitz Training Center - ${location.city}`,
          "description": `Professional cloud computing and technology training center in ${location.city}, ${location.state}`,
          "url": `https://cloudblitz.in/training/${location.city.toLowerCase().replace(/\s+/g, '-')}`,
          "telephone": location.phone,
          "email": location.email,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": location.city,
            "addressRegion": location.state,
            "addressCountry": "IN",
            "streetAddress": location.address
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": location.coordinates.lat,
            "longitude": location.coordinates.lng
          },
          "openingHours": "Mo-Fr 09:00-18:00, Sa 09:00-17:00",
          "priceRange": "₹₹",
          "currenciesAccepted": "INR",
          "paymentAccepted": "Cash, Credit Card, Bank Transfer, UPI",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": `Training Courses in ${location.city}`,
            "itemListElement": location.courses.map(course => ({
              "@type": "Offer",
              "itemOffered": {
                "@type": "Course",
                "name": course,
                "description": `${course} training in ${location.city}`,
                "provider": {
                  "@type": "Organization",
                  "name": "CloudBlitz"
                }
              }
            }))
          }
        }
      }))
    };

    return JSON.stringify(structuredData);
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-gray-900 to-black text-white relative overflow-hidden">
      {/* Structured Data for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: generateLocationStructuredData()
        }}
      />
      {/* Enhanced Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-orange-500/5 via-purple-500/5 to-transparent"></div>
        <div className="absolute top-20 right-20 w-32 h-32 bg-orange-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 left-20 w-40 h-40 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-gradient-to-r from-orange-500/10 to-purple-500/10 rounded-full blur-2xl animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>
      
      <Meteors number={15} />
              <div className="mx-auto max-w-7xl px-6 py-8 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo.webp" 
                alt="CloudBlitz" 
                className="h-10 w-auto lg:h-12" 
                loading="lazy"
                decoding="async"
                width="200"
                height="60"
              />
            </Link>
            <p className="text-gray-300 text-sm leading-6">
              To be India's most trusted and result-driven technology training institute, recognized globally for producing highly skilled, job-ready professionals who shape the future of technology. We envision transforming careers by providing not just education, but also lifelong learning opportunities, ensuring our students thrive in the fast-evolving digital world.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/cloudblitz" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-orange-400 transition-colors group"
                onClick={() => trackSocialClick('facebook', 'footer')}
              >
                <Facebook className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
              </a>
              <a 
                href="https://x.com/CloudBlitz_" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-orange-400 transition-colors group"
                onClick={() => trackSocialClick('twitter', 'footer')}
              >
                <Twitter className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
              </a>
              <a 
                href="https://www.linkedin.com/company/cloudblitz/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-purple-400 transition-colors group"
                onClick={() => trackSocialClick('linkedin', 'footer')}
              >
                <Linkedin className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
              </a>
              <a 
                href="https://www.instagram.com/cloudblitz.in" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-pink-400 transition-colors group"
                onClick={() => trackSocialClick('instagram', 'footer')}
              >
                <Instagram className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
              </a>
              <a 
                href="https://www.youtube.com/@cloudblitzz" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-red-400 transition-colors group"
                onClick={() => trackSocialClick('youtube', 'footer')}
              >
                <Youtube className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition-colors text-sm">
                  All Courses
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="https://hire.cloudblitz.in" className="text-gray-300 hover:text-orange-400 transition-all duration-300 text-sm group relative overflow-hidden">
                  <span className="relative z-10 group-hover:text-white">Hire From Us</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                </Link>
              </li>
              <li>
                <Link to="/be-a-mentor" className="text-gray-300 hover:text-orange-400 transition-all duration-300 text-sm group relative overflow-hidden">
                  <span className="relative z-10 group-hover:text-white">Be A Mentor</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                </Link>
              </li>
              <li>
                <Link to="/franchise" className="text-orange-400 font-semibold hover:text-white transition-all duration-300 text-sm group relative overflow-hidden inline-block px-2 py-1 -mx-2 -my-1 rounded">
                  <span className="relative z-10">
                    <span className="bg-gradient-to-r from-orange-500 to-purple-600 bg-clip-text text-transparent group-hover:text-white transition-colors">Franchise Opportunity</span>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-purple-600 opacity-20 group-hover:opacity-100 transform scale-x-0 group-hover:scale-x-100 transition-all duration-300 origin-left rounded"></div>
                </Link>
              </li>
            </ul>
          </div>

          {/* Courses */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Popular Courses</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/courses/cloud-devops-engineering-ai" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Cloud DevOps Engineering with AI
                </Link>
              </li>
              <li>
                <Link to="/courses/integrated-fullstack-cloud-devops-ai" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Full Stack with Cloud DevOps
                </Link>
              </li>
              <li>
                <Link to="/courses/expert-data-science-analytics-ai" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Data Science & Analytics with AI
                </Link>
              </li>
              <li>
                <Link to="/courses/expert-digital-marketing-ai" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Expert in Digital Marketing with AI
                </Link>
              </li>
              <li>
                <Link to="/courses/ultimate-cloud-architect" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Ultimate Cloud Architect
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 group">
                <Phone className="h-5 w-5 text-orange-400 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-gray-300 text-sm group-hover:text-orange-400 transition-colors">
                  +91 98348 87259
                </span>
              </div>
              <div className="flex items-center space-x-3 group">
                <Mail className="h-5 w-5 text-purple-400 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-gray-300 text-sm group-hover:text-purple-400 transition-colors">
                  info@cloudblitz.in
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="h-5 w-5 text-green-400 flex items-center justify-center">
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                  </svg>
                </div>
                <a 
                  href="https://wa.me/919834887259?text=Hi! I'm interested in learning more about CloudBlitz courses. Can you help me?"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-green-400 transition-colors text-sm flex items-center group"
                >
                  <span>WhatsApp us</span>
                  <div className="ml-1 w-2 h-2 bg-green-400 rounded-full animate-pulse group-hover:scale-150 transition-transform"></div>
                </a>
              </div>
            </div>
            
            {/* App Store Links - Aligned Design */}
            <div className="pt-4 border-t border-gray-700">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                {/* Android App - Play Store */}
                <a 
                  href="https://play.google.com/store/apps/details?id=com.edmingle.edublitz&hl=en_IN&pli=1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-all duration-300 group"
                >
                  <div className="h-6 w-6 text-blue-400 flex items-center justify-center flex-shrink-0">
                    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                    </svg>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-gray-400 group-hover:text-blue-400 transition-colors">Get it on</span>
                    <span className="text-sm font-medium">Google Play</span>
                  </div>
                </a>
                
                {/* Apple App Store */}
                <a 
                  href="https://apps.apple.com/in/app/edublitz/id6758005017"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-300 hover:text-gray-100 transition-all duration-300 group"
                >
                  <div className="h-6 w-6 text-gray-100 flex items-center justify-center flex-shrink-0">
                    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.16c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                    </svg>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-gray-400 group-hover:text-gray-100 transition-colors">Download on the</span>
                    <span className="text-sm font-medium">App Store</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Office Locations Section */}
        <div className="mt-6 pt-4 border-t border-gray-800">
          <div className="text-center mb-6">
            <div className="inline-flex items-center space-x-2 mb-2">
              <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></div>
              <h3 className="text-lg font-bold text-white">Nationwide Presence</h3>
              <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse"></div>
            </div>
            <p className="text-gray-400 text-sm">Visit any of our state-of-the-art training centers across India</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {officeLocations.map((office, index) => (
              <div key={index} className={`rounded-lg p-2.5 transition-all duration-300 border group relative overflow-visible hover:shadow-lg cursor-pointer ${
                office.status === 'active' 
                  ? 'bg-gray-800/50 hover:bg-gray-800/70 border-gray-700/50 hover:border-orange-400/30' 
                  : 'bg-gray-800/30 hover:bg-gray-800/50 border-gray-600/30 hover:border-orange-400/30'
              }`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className={`w-1.5 h-1.5 rounded-full ${
                      office.status === 'active' 
                        ? 'bg-orange-400 animate-pulse' 
                        : 'bg-orange-400 animate-pulse'
                    }`}></div>
                    <h4 className={`font-semibold transition-colors text-sm ${
                      office.status === 'active' 
                        ? 'text-white group-hover:text-orange-400' 
                        : 'text-white group-hover:text-orange-400'
                    }`}>
                      {office.city}
                    </h4>
                    {office.status === 'opening-soon' && (
                      <span className="inline-flex items-center px-1 py-0.5 rounded-full text-xs font-medium bg-orange-400/20 text-orange-300 border border-orange-400/30">
                        Soon
                      </span>
                    )}
                  </div>
                  {office.status === 'active' && (
                    <div className="text-gray-400 group-hover:text-orange-400 transition-colors p-0.5">
                      <MapPin className="h-3 w-3" />
                    </div>
                  )}
                </div>
                
                {/* Clickable overlay for Google Maps */}
                {office.status === 'active' && (
                  <a 
                    href={office.mapLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="absolute inset-0 z-10"
                    title={`View ${office.city} on Google Maps`}
                  >
                  </a>
                )}
                
                {/* Address popup on hover */}
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-3 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out pointer-events-none z-50">
                  <div className="bg-gray-900/95 backdrop-blur-sm border border-gray-700/50 rounded-lg p-4 shadow-2xl max-w-sm">
                    <div className="text-center space-y-3">
                      <h5 className="text-white font-semibold text-sm">{office.city}</h5>
                      <p className="text-gray-300 text-xs leading-relaxed text-left">
                        {office.address}
                      </p>
                      {office.status === 'active' ? (
                        <div className="flex items-center justify-center space-x-1 pt-1 border-t border-gray-700/50">
                          <MapPin className="h-3 w-3 text-orange-400" />
                          <span className="text-orange-400 text-xs font-medium">Click to open map</span>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center space-x-1 pt-1 border-t border-gray-700/50">
                          <div className="w-2 h-2 rounded-full bg-orange-400 animate-ping"></div>
                          <span className="text-orange-400 text-xs font-medium">Opening Soon</span>
                        </div>
                      )}
                    </div>
                    {/* Arrow pointing down */}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900/95"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* View More Button */}
          <div className="text-center mt-4">
            <button 
              onClick={() => setShowSeoKeywords(!showSeoKeywords)}
              className="inline-flex items-center px-3 py-2 bg-gradient-to-r from-orange-500 to-purple-600 text-white text-xs rounded-lg hover:from-orange-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              {showSeoKeywords ? 'Hide' : 'View More'}
              <svg 
                className={`ml-1 h-3 w-3 transition-transform ${showSeoKeywords ? 'rotate-180' : ''}`}
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>

          {/* SEO Keywords Section */}
          {showSeoKeywords && (
            <div className="mt-6 p-6 bg-gradient-to-br from-gray-800/30 to-gray-900/30 backdrop-blur-sm rounded-xl border border-gray-700/30 shadow-xl">
              <h4 className="text-sm font-medium text-white mb-4 text-center flex items-center justify-center">
                <div className="w-2 h-2 bg-orange-400 rounded-full mr-2 animate-pulse"></div>
                Training Locations
                <div className="w-2 h-2 bg-purple-400 rounded-full ml-2 animate-pulse"></div>
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {seoKeywords.map((location, index) => (
                  <div key={index} className="space-y-1 p-3 rounded-lg hover:bg-gray-800/20 transition-colors group">
                    <h5 className="font-medium text-orange-300 text-xs group-hover:text-orange-200 transition-colors">{location.location}</h5>
                    <ul className="space-y-0.5">
                      {location.courses.map((course, courseIndex) => (
                        <li key={courseIndex} className="text-gray-400 text-xs hover:text-gray-300 transition-colors">
                          {course}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2019 - 2026  CloudBlitz | Powered by Greamio. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                Terms of Service
              </Link>
              <Link to="/refund" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
} 